export default "__VITE_ASSET__CY7dYiaI__"